<template>
  <div class="print-description-wrapper">
    <div class="total-title">360.cn集团邮箱归档方法</div>
    <div class="title">1. 目的</div>
    <p>为了方便360.CN集团用户进行邮件归档</p>
    <div class="title">2. 适用范围</div>
    <p>360集团内部，邮箱为XXX@360.CN</p>
    <div class="title">3. 权责声明</div>
    <p>此文档为360信息化部IT所编写，版权归360信息化部所有。此文档禁止用于商业用途，禁止分享传播到公司外部组织，如有违反，将按照HR员工手册和信息安全部相关规章制度进行处理。</p>
    <div class="title">4. 如何查询当前邮箱大小？</div>
    <p>
      1. 浏览器打开
      <a tag="a" href="https://mail.corp.qihoo.net/owa">https://mail.corp.qihoo.net/owa</a>
      <br />2. 点击右上角“设置”按钮
      <img src="../../assets/img/pdf2H5/img_1.png" class="inline-img" />
      <br />3. 点击选项
      <img src="../../assets/img/pdf2H5/img_2.png" />
      4. 点击“常规”——“我的账户”
      <img src="../../assets/img/pdf2H5/img_3.png" />
    </p>
    <div class="title">5. 将邮件归档到“本地电脑”</div>
    <p>
      1. 点击Outlook左上角“文件”
      <img src="../../assets/img/pdf2H5/img_4.png" />
      2. 点击“清理旧项目”
      <img src="../../assets/img/pdf2H5/img_5.png" />
      3. 选择要归档设置
      <br />
      <span class="twoem">
        1) 选择要归档的邮箱地址 （
        <span class="red">不要选择单个文件夹</span>）
      </span>
      <br />
      <span class="twoem">2) 选择日期，将早于该时间的邮件归档</span>
      <br />
      <span class="twoem">3) 避免将归档文件存放在非C盘系统盘 ，如 D盘下创建mail文件夹</span>
      <img src="../../assets/img/pdf2H5/img_6.png" />
    </p>
    <div class="title">6. 将邮件归档到“归档服务器”（推荐）</div>
    <p class="red">前提条件：</p>
    <p class="weight twoem">邮箱大小没有超过配额限制，查询邮箱大小参考4.0如何查询当前邮箱大小？</p>
    <p>
      1. 打开Outlook，选中要归档到服务器的文件夹 ，比如“收件箱”
      <br />2. 点击右上角的“Enterprise Vault”，点击“存储”——“存储选定的项目”
      <img src="../../assets/img/pdf2H5/img_7.png" />
      3. Enterprise Vault归档插件安装：
      <br />
      <span class="twoem">
        内网环境下安装，如有问题，发送邮件至IT@360.CN 或拨打 58781234 -转1
        \\file1\常用软件\Outlook归档邮件插件\查看归档邮件工具
      </span>
    </p>

    <div class="title">7. 调整归档邮件的频率（推荐）</div>
    <p class="red">前提条件：</p>
    <p class="weight twoem">邮箱大小没有超过配额限制，查询邮箱大小参考4.0如何查询当前邮箱大小？</p>
    <p>
      1. 360.CN邮箱默认归档2个月前的邮件
      <br />2. 如需调整，可发邮件至IT@360.CN ，申请调整。
      <span class="twoem">
        比如：
        <br />
        <span class="twoem" style="margin-left: 2em;">申请调整邮件归档策略为“归档2周前的邮件”。</span>
      </span>
      <img src="../../assets/img/pdf2H5/img_8.png" />
    </p>
  </div>
</template>
<script>
export default{
  
}
</script>
<style lang="scss" scoped>
.print-description-wrapper {
  min-height: 100vh;
  padding: 15px;
  background: #fff;
  font-size: 14px;
  img {
    width: 100%;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
  }
  p {
    margin: 1em 0;
  }
  .sub-title {
    font-weight: bold;
  }
  .total-title {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    padding: 1em 0;
  }
  .inline-img {
    display: inline;
    vertical-align: middle;
    width: 30px;
  }
  .red {
    color: red;
  }
  .twoem {
    /* text-indent: 2em; */
    margin-left: 1em;
  }
  .weight {
    font-weight: bold;
  }
  a {
    color: $link-a;
  }
}
</style>